import { COMPANY_TYPE_ID, CONTACT_TYPE_ID, DEAL_TYPE_ID, TICKET_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { Avatar } from 'avatar-components/Avatar';
import { jsx as _jsx } from "react/jsx-runtime";
export const getAvatarLookupType = ({
  objectTypeId
}) => {
  switch (objectTypeId) {
    case COMPANY_TYPE_ID:
      return 'companyId';
    case CONTACT_TYPE_ID:
      return 'vid';
    default:
      return undefined;
  }
};
export const getAvatarProps = ({
  objectTypeId,
  objectId
}) => {
  switch (objectTypeId) {
    case COMPANY_TYPE_ID:
      return {
        companyId: objectId
      };
    case CONTACT_TYPE_ID:
      return {
        vid: objectId
      };
    default:
      return undefined;
  }
};
export const AvatarLookup = ({
  objectTypeId,
  objectId,
  size = 'lg'
}) => {
  if (objectTypeId === COMPANY_TYPE_ID) {
    return /*#__PURE__*/_jsx(Avatar, {
      size: size,
      companyId: objectId
    });
  }
  if (objectTypeId === CONTACT_TYPE_ID) {
    return /*#__PURE__*/_jsx(Avatar, {
      size: size,
      vid: objectId
    });
  }
  if (objectTypeId === DEAL_TYPE_ID) {
    return /*#__PURE__*/_jsx(Avatar, {
      size: size,
      type: "deal"
    });
  }
  if (objectTypeId === TICKET_TYPE_ID) {
    return /*#__PURE__*/_jsx(Avatar, {
      size: size,
      type: "ticket"
    });
  }
  return /*#__PURE__*/_jsx(Avatar, {
    size: size
  });
};